import { render, staticRenderFns } from "./profile-detail.vue?vue&type=template&id=612a1b7b&scoped=true"
import script from "./profile-detail.vue?vue&type=script&lang=js"
export * from "./profile-detail.vue?vue&type=script&lang=js"
import style0 from "./profile-detail.vue?vue&type=style&index=0&id=612a1b7b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612a1b7b",
  null
  
)

export default component.exports